import React, { lazy } from 'react';

import { useNavigateToPrevious } from 'lib/redirect';

const WithdrawModal = lazy(() => import('./WithdrawModal'));

function WithdrawMobilePage() {
  const navigateToPrevious = useNavigateToPrevious('/wallet/menu-mobile');
  return (
    <>
      <WithdrawModal onClose={navigateToPrevious} />
    </>
  );
}

export default WithdrawMobilePage;
